import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { SHADOW_LEVEL1, SHADOW_LEVEL2, styled } from '@ori-ui/mui';
import { FONT_SANS_ORI } from "../../../common";
export var Root = styled('a')(function (_ref) {
  var href = _ref.href,
    theme = _ref.theme;
  return _defineProperty({
    background: theme.palette.common.white,
    borderRadius: '10px',
    boxShadow: SHADOW_LEVEL1,
    cursor: 'default',
    display: 'grid',
    fontFamily: FONT_SANS_ORI,
    overflow: 'hidden',
    padding: theme.spacing(3),
    position: 'relative',
    textDecoration: 'none',
    WebkitTapHighlightColor: 'transparent'
  }, theme.breakpoints.up('sm'), {
    cursor: href ? 'pointer' : 'default',
    display: 'flex',
    height: '220px',
    maxWidth: '600px',
    padding: 0,
    '&:hover': {
      boxShadow: href ? SHADOW_LEVEL2 : SHADOW_LEVEL1
    }
  });
});
export var Brand = styled('div')(function (_ref3) {
  var theme = _ref3.theme;
  return _defineProperty({
    alignItems: 'center',
    display: 'flex',
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightBold,
    letterSpacing: '2.4px',
    textAlign: 'center',
    textTransform: 'uppercase',
    svg: {
      fontSize: theme.typography.pxToRem(18)
    }
  }, theme.breakpoints.up('sm'), {
    textAlign: 'left'
  });
});
export var Name = styled('div')(function (_ref5) {
  var theme = _ref5.theme;
  return {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightBold,
    marginTop: theme.spacing(1),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  };
});
export var Description = styled('div')(function (_ref6) {
  var theme = _ref6.theme;
  return {
    boxOrient: 'vertical',
    display: '-webkit-box',
    fontSize: theme.typography.pxToRem(14),
    lineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2
  };
});
export var Buttons = styled('div')(function (_ref7) {
  var theme = _ref7.theme;
  return _defineProperty({
    display: 'flex',
    flexFlow: 'column',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2)
  }, theme.breakpoints.up('sm'), {
    flexFlow: 'row'
  });
});
export var Info = styled('div')(function (_ref9) {
  var theme = _ref9.theme;
  return _defineProperty({
    color: theme.palette.text.primary,
    overflow: 'hidden'
  }, theme.breakpoints.up('sm'), {
    alignSelf: 'center',
    padding: theme.spacing(0, 6),
    width: '100%'
  });
});
//# sourceMappingURL=root.js.map